enum EUser {
  loginUser = "auth/login",
  getMy = "users/get-my",
  deleteMy = "delete/my",
  patchMy = "users/patch-my",
  sendVerificationCode = "users/send-verification-code",
  verifyCode = "users/verify-code",
  registerUser = "auth/register",
  logOutUser = "auth/log-out",
  refreshToken = "auth/refresh-token",
  sendVerificationLink = "auth/send-verification-link",
  updatePassword = "auth/update-password",
  resetPassword = "auth/reset-password",
  updateEmail = "auth/update-email",
  validateResetToken = "auth/validate-reset-token",
  passwordChangeStart = "auth/password-change/start",
  passwordChangeVerify = "auth/password-change/verify",
  passwordChangeCommit = "auth/password-change/commit",
  passwordChangeCancel = "auth/password-change/cancel",
  accountDeleteStart = "auth/account-delete/start",
  accountDeleteVerify = "auth/account-delete/verify",
  accountDeleteCancel = "auth/account-delete/cancel",
  captcha = "captcha",
}

export default EUser;
